import { useState } from 'react';
import './Contact.css';

const faqs = [
  { q: 'How do I register my mandal on Aarambh?', a: 'Go to the Register page, fill in your mandal details across three steps and submit. Our team will review and approve within 2–3 working days.' },
  { q: 'Is registration free?', a: 'Yes, registration is completely free for all Ganpati Mahotsav Mandal based in Valsad district. There are no hidden charges.' },
  { q: 'How are donations used?', a: 'Donations are used for Ganesh Utsav celebrations, social activities (medical camps, tree plantation, etc.) and community welfare. Monthly expenditure reports are published.' },
  { q: 'Can I donate anonymously?', a: 'Yes. When making a donation you can tick the "Donate anonymously" option and your name will not be displayed publicly.' },
  { q: 'My mandal is outside Valsad — can we register?', a: 'As of now, Aarambh covers Valsad district only. We plan to expand to other districts and cities soon. Stay tuned!' },
  { q: 'How do I propose a social activity?', a: 'Use the Contact form on this page or visit our Events page and click "Propose an Activity". Our team will get in touch with you.' },
];

export default function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="contact-page">
      <div className="page-hero">
        <div className="container">
          <div className="badge">Get in Touch</div>
          <h1>Contact Us</h1>
          <p>Have a question about registration, donations or events? We'd love to hear from you — reach out any time.</p>
        </div>
      </div>

      <section>
        <div className="container contact-layout">
          {/* Contact Info */}
          <div className="contact-info">
            <h2>Let's Connect</h2>
            <p>Whether you want to register your mandal, inquire about donations, or propose a social activity — our team is here to help.</p>

            <div className="info-cards">
              <div className="info-card card">
                <div className="info-icon">📍</div>
                <div>
                  <h4>Our Office</h4>
                  <p>Aarambh Charitable Trust<br />Valsad, Gujarat – 396001<br />India</p>
                </div>
              </div>
              <div className="info-card card">
                <div className="info-icon">📞</div>
                <div>
                  <h4>Phone</h4>
                  <p>+91 99999 00000<br />Mon – Sat, 9 AM – 6 PM</p>
                </div>
              </div>
              <div className="info-card card">
                <div className="info-icon">✉️</div>
                <div>
                  <h4>Email</h4>
                  <p>info@aarambh.org<br />reply within 24 hours</p>
                </div>
              </div>
              <div className="info-card card">
                <div className="info-icon">💬</div>
                <div>
                  <h4>WhatsApp</h4>
                  <p>+91 99999 00000<br />Quick responses on WhatsApp</p>
                </div>
              </div>
            </div>

            <div className="social-section">
              <h3>Follow Us</h3>
              <div className="social-links">
                <a href="#!" className="social-link-btn" aria-label="Facebook">
                  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
                  Facebook
                </a>
                <a href="#!" className="social-link-btn" aria-label="Instagram">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
                  Instagram
                </a>
                <a href="#!" className="social-link-btn" aria-label="YouTube">
                  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/><polygon fill="white" points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/></svg>
                  YouTube
                </a>
                <a href="#!" className="social-link-btn" aria-label="WhatsApp">
                  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.119.554 4.107 1.523 5.832L.057 23.428a.5.5 0 0 0 .609.61l5.703-1.49A11.943 11.943 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.882a9.877 9.877 0 0 1-5.031-1.378l-.361-.214-3.733.976.999-3.648-.235-.374A9.859 9.859 0 0 1 2.118 12C2.118 6.533 6.533 2.118 12 2.118S21.882 6.533 21.882 12 17.467 21.882 12 21.882z"/></svg>
                  WhatsApp
                </a>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-col">
            {submitted ? (
              <div className="success-card card" style={{ textAlign: 'center', padding: '48px 32px' }}>
                <div style={{ fontSize: '3.5rem' }}>🙏</div>
                <h2>Message Sent!</h2>
                <p>Thank you for reaching out. We will get back to you at <strong>{email}</strong> within 24 hours.</p>
                <button className="btn-primary" style={{ marginTop: 20 }} onClick={() => setSubmitted(false)}>Send Another Message</button>
              </div>
            ) : (
              <form className="contact-form card" onSubmit={handleSubmit}>
                <h2>Send a Message</h2>
                <div className="field-row-2">
                  <div className="cfield-group">
                    <label>Your Name *</label>
                    <input className="form-input" placeholder="Full name" value={name} onChange={(e) => setName(e.target.value)} required />
                  </div>
                  <div className="cfield-group">
                    <label>Email *</label>
                    <input className="form-input" type="email" placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
                  </div>
                </div>
                <div className="field-row-2">
                  <div className="cfield-group">
                    <label>Phone</label>
                    <input className="form-input" type="tel" placeholder="+91 99999 00000" value={phone} onChange={(e) => setPhone(e.target.value)} />
                  </div>
                  <div className="cfield-group">
                    <label>Subject *</label>
                    <select className="form-input" value={subject} onChange={(e) => setSubject(e.target.value)} required>
                      <option value="">Select subject</option>
                      <option>Mandal Registration</option>
                      <option>Donation Query</option>
                      <option>Social Activity</option>
                      <option>Events Information</option>
                      <option>General Inquiry</option>
                      <option>Partnership</option>
                    </select>
                  </div>
                </div>
                <div className="cfield-group">
                  <label>Message *</label>
                  <textarea className="form-input" rows={5} placeholder="Tell us how we can help you..." value={message} onChange={(e) => setMessage(e.target.value)} required />
                </div>
                <button type="submit" className="btn-primary" style={{ width: '100%', padding: '15px' }}>
                  📨 Send Message
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="faq-section">
        <div className="container">
          <div className="section-header">
            <div className="badge">FAQ</div>
            <h2>Frequently Asked Questions</h2>
            <div className="divider">
              <div className="divider-line" />
              <span className="divider-icon">🌸</span>
              <div className="divider-line right" />
            </div>
          </div>
          <div className="faq-list">
            {faqs.map((faq, i) => (
              <div key={i} className={`faq-item card${openFaq === i ? ' open' : ''}`}>
                <button className="faq-question" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                  <span>{faq.q}</span>
                  <span className="faq-icon">{openFaq === i ? '−' : '+'}</span>
                </button>
                {openFaq === i && <p className="faq-answer">{faq.a}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
